import React from "react";
import Tab from "./Tab";

const Tabs = ({ children, options, selectedOption, onChange, renderTabLabel }) => {
    return (
        <div className="tabs" value={selectedOption.index}>
            <div className="tabs__nav">
                {options.map((option) => (
                    <Tab
                        label={renderTabLabel(option.label, option.notificationsKeyIdentity)}
                        selected={option.index === selectedOption.index}
                        key={option.index}
                        icon={option.icon}
                        disabled={option.disabled}
                        onClick={() => onChange(option, option.index)}
                    />
                ))}
            </div>
            <div className="tabs__content">{selectedOption.component || children}</div>
        </div>
    );
};

Tabs.propTypes = {};
Tabs.defaultProps = {};

export default Tabs;
